import { __ } from '@wordpress/i18n';
import { useEffect, useState } from '@wordpress/element';

const FILTER_CONTROLS = [
	{ key: 'blur', label: 'Blur', min: 0, max: 10, step: 0.5, unit: 'px', class: 'vb-filter-blur' },
	{ key: 'brightness', label: 'Brightness', min: 0, max: 200, step: 1, class: 'vb-filter-brightness' },
	{ key: 'contrast', label: 'Contrast', min: 0, max: 200, step: 1, class: 'vb-filter-contrast' },
	{ key: 'saturation', label: 'Saturation', min: 0, max: 200, step: 1, class: 'vb-filter-saturation' },
	{ key: 'hue', label: 'Hue', min: 0, max: 360, step: 1, unit: 'deg', class: 'vb-filter-hue' },
];

export const VayuBlocksCssFilters = ({ data, onChange, headingLabel="Filter" }) => {
	const [isOpen, setIsOpen] = useState(false);

    // 👉 Open panel if any filter is active (non-zero)
	useEffect(() => {
		const hasAnyValue = FILTER_CONTROLS.some(
			({ key }) => parseFloat(data?.value?.[key] || 0) !== 0
		);
		if (hasAnyValue) {
			setIsOpen(true);
		}
	}, [data?.value]);

	const handleChange = (filterKey, val) => {
		const updated = {
			...data?.value,
			[filterKey]: val,
		};
		onChange(data?.key, updated);
	};

	const handleReset = () => {
		onChange(data?.key, {});
	};

	return (
		<div className="vb-filter-wrapper">
			<div className="vb-filter-header">
                <button
                    type="button"
                    className="vb-filter-toggle"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? `▾ ${headingLabel}` : `▸ ${headingLabel}`}
                </button>

                {isOpen && (
                    <button
                        type="button"
                        className="vb-filter-reset"
                        onClick={handleReset}
                    >
                        Reset
                    </button>
                )}
            </div>

	
			<div className={`vb-filter-components ${isOpen ? 'vb-open' : ''}`}>
				{FILTER_CONTROLS.map(({ key, label, min, max, step, class: className }) => (
					<div className={`vb-slider-row ${className}`} key={key}>
						<label htmlFor={`filter-${key}`}>{__(label, 'vayu-blocks')}</label>

						<input
							type="range"
							id={`filter-${key}`}
							min={min}
							max={max}
							step={step}
							value={data?.value?.[key] || 0}
							onChange={(e) => handleChange(key, parseFloat(e.target.value))}
							className="vb-custom-slider"
						/>

						<input
							type="number"
							className="vb-slider-value"
							min={min}
							max={max}
							step={step}
							value={data?.value?.[key] || 0}
							onChange={(e) => handleChange(key, parseFloat(e.target.value))}
						/>

						{/* Per-filter reset icon */}
						<button
							type="button"
							className="vb-filter-individual-reset"
							onClick={() => handleChange(key, 0)}
							title={`Reset ${label}`}
						>
							↺
						</button>
					</div>
				))}
			</div>
	
		</div>
	);
};
